import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    if (!historyItems || !historyItems.length) {
        return
    }

    return (
        <div class="ns-autocomplete ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box">
            <div class="ns-d-flex ns-flex-column ns-flex-grow-1 gap-y-4">
                {<div class="utility text-t-brand-foreground-secondary">
                    Recently Searched
                </div>}
                <div class="ns-d-flex ns-flex-column ns-align-items-start gap-y-xs">
                    {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                        <HistoryElement key={item} query={{ query: item }}>
                            <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable body-l text-[0.75rem] text-t-brand-foreground-secondary hover:text-t-foreground transition-[color] duration-300 ease-out">
                                {item}
                            </div>
                        </HistoryElement>
                    ))}
                </div>
            </div>
        </div>
    )
}
